import { render, staticRenderFns } from "./CoozzyFormCountrySelect.vue?vue&type=template&id=c65317ea&scoped=true"
import script from "./CoozzyFormCountrySelect.vue?vue&type=script&lang=js"
export * from "./CoozzyFormCountrySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65317ea",
  null
  
)

export default component.exports